import React from 'react';
import { weakKey } from '../../../../../../utilities/weakKey';
import { UnitAvailabilityTypes } from '../../UnitAvailabilityTypes';
import {
  doesElementExistsFilterInArray,
  onFilterChange,
} from './viewRatesFilterHelper';
import { Text } from '../../../../../../components/textVariations';
import { Icon } from '../../../../../../utilities/icomoon-css';
import {
  AMENITIES_TYPE_FILTER,
  AMENITIES_TYPE_FILTER_NAME,
  UNIT_SIZE_FILTER,
  UNIT_TYPE_FILTER_NAME,
} from '../constants/viewRatesFilterConfig';

export const RenderFilterCheckBoxSection = ({
  activeFilterStateHandler,
  heightForTop,
  typeFilter,
  unitsFilter,
  activeFilters,
}: UnitAvailabilityTypes.TRenderCheckboxSection) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: `${heightForTop}px`,
        right: '0px',
      }}
      className="checkBoxSection"
    >
      {unitsFilter.map(indivUnitType => {
        if (indivUnitType.type === typeFilter) {
          return (
            <div
              className="filterCheckBox"
              onClick={() =>
                onFilterChange(
                  indivUnitType,
                  activeFilters,
                  activeFilterStateHandler,
                  unitsFilter
                )
              }
              key={weakKey(indivUnitType)}
            >
              <label className="label">{indivUnitType.value}</label>
              <input
                id={weakKey({ indivUnitType })}
                type="checkbox"
                onChange={() => {}}
                checked={
                  (activeFilters &&
                    doesElementExistsFilterInArray(
                      activeFilters,
                      indivUnitType
                    )) ||
                  false
                }
              />
              <span className="filterCheckboxSpan"></span>
            </div>
          );
        }
      })}
    </div>
  );
};

export const SubFilterSection = ({
  filterType,
  currStatus,
  heightFromTop,
  typeFilter,
  sectionText,
  changeFilterDropDownStatus,
  smallScreenActiveFilter,
  smallScreenFilterHandler,
  unitsFilter,
}: UnitAvailabilityTypes.TViewRatesSmallScreenSubSection) => {
  return (
    <div className="smallSubFilterSection">
      <div
        className="headingSection"
        onClick={() => changeFilterDropDownStatus(filterType)}
      >
        <Text renderAs={'p'}>{sectionText}</Text>
        <Icon name={currStatus ? 'tfw-minus-cirlce-cp' : 'tfw-add-circle-cp'} />
      </div>
      {currStatus && (
        <SmallScreenCheckBoxSection
          heightForTop={heightFromTop}
          typeFilter={typeFilter}
          activeFilters={smallScreenActiveFilter}
          unitsFilter={unitsFilter}
          onChangeHandler={smallScreenFilterHandler}
        />
      )}
    </div>
  );
};

export const SmallScreenCheckBoxSection = ({
  activeFilters,
  heightForTop,
  onChangeHandler,
  typeFilter,
  unitsFilter,
}: UnitAvailabilityTypes.TRenderSmallScreenCheckboxSection) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: `${heightForTop}px`,
        right: '0px',
      }}
      className="checkBoxSection"
    >
      {unitsFilter.map(indivUnitType => {
        if (indivUnitType.type === typeFilter) {
          return (
            <div
              className="filterCheckBox"
              onClick={() => onChangeHandler(indivUnitType)}
              key={weakKey(indivUnitType)}
            >
              <label className="label">{indivUnitType.value}</label>
              <input
                id={weakKey({ indivUnitType })}
                type="checkbox"
                onChange={() => {}}
                checked={
                  (activeFilters &&
                    doesElementExistsFilterInArray(
                      activeFilters,
                      indivUnitType
                    )) ||
                  false
                }
              />
              <span className="filterCheckboxSpan"></span>
            </div>
          );
        }
      })}
    </div>
  );
};

export const FilterSection = ({
  filterType,
  currentStatus,
  heightForTop,
  activeFilters,
  activeFilterStateHandler,
  divRef,
  filterRef,
  unitsFilter,
  changeFilterDropDownStatus,
}: UnitAvailabilityTypes.TReusableFilterSection) => {
  return (
    <div className={`filterSection`} ref={divRef}>
      <div className="clickableFilterSection" ref={filterRef}>
        <div
          className="changeFilterSection"
          onClick={() => {
            changeFilterDropDownStatus(filterType);
          }}
        >
          <p className="subtitle1 pl-4">
            {filterType == 'amenities'
              ? AMENITIES_TYPE_FILTER_NAME
              : UNIT_TYPE_FILTER_NAME}
          </p>
          <div className="iconSection">
            <Icon
              name={
                currentStatus
                  ? 'tfw-arrow-up-bold-2-cp'
                  : 'tfw-arrow-down-bold-2-cp'
              }
            />
          </div>
        </div>
        {currentStatus && (
          <RenderFilterCheckBoxSection
            heightForTop={heightForTop}
            typeFilter={
              filterType === 'amenities'
                ? AMENITIES_TYPE_FILTER
                : UNIT_SIZE_FILTER
            }
            activeFilters={activeFilters}
            activeFilterStateHandler={activeFilterStateHandler}
            unitsFilter={unitsFilter}
          />
        )}
      </div>
    </div>
  );
};
